// removed by extract-text-webpack-plugin
module.exports = {"lastUpdated":"finance-blocks_last-updated_lastUpdated","disclaimer":"finance-blocks_last-updated_disclaimer"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-blocks/src/components/last-updated/style.less
// module id = 796
// module chunks = 0